export const ANY_TRIGGER_AUTHOR = 'Any';
export const FILTER_PIPELINES_SEARCH_DELAY = 200;
export const SCHEDULE_ORIGIN = 'schedule';
export const API_ORIGIN = 'api';
export const TRIGGER_ORIGIN = 'trigger';
